import { render, staticRenderFns } from "./PaymentLoader.vue?vue&type=template&id=58f647f3&scoped=true&"
import script from "./PaymentLoader.vue?vue&type=script&lang=js&"
export * from "./PaymentLoader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLoader.vue?vue&type=style&index=0&id=58f647f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f647f3",
  null
  
)

export default component.exports